(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-video-carousel_1"] && !Shopify.designMode) return;
  try {
    
  class ArtistVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-avc-track]');
      this.dialog = this.querySelector('[data-avc-dialog]');
      this.dialogMedia = this.querySelector('[data-avc-dialog-media]');
      this.quoteEl = this.querySelector('[data-avc-quote]');
      this.metaEl = this.querySelector('[data-avc-meta]');
      this.prevBtn = this.querySelector('[data-avc-prev]');
      this.nextBtn = this.querySelector('[data-avc-next]');

      this.querySelectorAll('[data-avc-open]').forEach((card) => {
        card.addEventListener('click', () => this.open(card));
      });

      this.querySelector('[data-avc-close]')?.addEventListener('click', () => this.dialog.close());

      // Click outside the dialog card closes it
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // Always tear the media down on close so nothing keeps playing
      this.dialog?.addEventListener('close', () => this.dialogMedia.replaceChildren());

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));
      this.track?.addEventListener('scroll', () => this.syncArrows(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.syncArrows());
      if (this.track) this.resizeObserver.observe(this.track);

      this.syncArrows();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    open(card) {
      const template = card.querySelector('template');
      if (template) {
        this.dialogMedia.replaceChildren(template.content.cloneNode(true));
      }

      const { artist = '', tag = '', quote = '', credit = '', ratio = '' } = card.dataset;

      // Resize the dialog to match this clip's orientation (16:9, 9:16, anything)
      const parsed = parseFloat(ratio);
      this.dialog.style.setProperty('--avc-ratio-num', Number.isFinite(parsed) && parsed > 0 ? parsed : 1.7778);

      this.quoteEl.textContent = quote ? '“' + quote + '”' : '';

      // Built with DOM nodes rather than innerHTML so merchant text is never parsed as markup
      this.metaEl.replaceChildren();
      if (artist || tag || credit) {
        const dot = document.createElement('span');
        dot.className = 'avc__dot';
        this.metaEl.append(dot);

        const parts = [];
        if (artist) {
          const strong = document.createElement('strong');
          strong.textContent = artist;
          parts.push(strong);
        }
        if (tag) parts.push(document.createTextNode(tag));
        if (credit) parts.push(document.createTextNode(credit));

        parts.forEach((node, index) => {
          if (index > 0) this.metaEl.append(document.createTextNode(' · '));
          this.metaEl.append(node);
        });
      }

      this.dialog.showModal();

      const video = this.dialogMedia.querySelector('video');
      if (video) video.play().catch(() => {});
    }

    step(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('.avc__slide');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card ? card.offsetWidth + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    syncArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevBtn.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      this.nextBtn.toggleAttribute('disabled', this.track.scrollLeft >= maxScroll);
    }
  }

  if (!customElements.get('artist-video-carousel')) {
    customElements.define('artist-video-carousel', ArtistVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
